import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { TagCreateComponent } from './tag-create/tag-create.component';
import { TagComponent } from './tag.component';
import { TagEditComponent } from './tag-edit/tag-edit.component';

export const tagsRoutes: Routes = [
  {
    path: 'tag',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: 'create',
        component: TagCreateComponent,
      },
      {
        path: ':tagId/edit',
        component: TagEditComponent,
      },
      {
        path: '',
        component: TagComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/tags/tag.routes.ts